import { render, staticRenderFns } from "./BillingRules.yaml?vue&type=template&id=48c7fb07&component"
import script from "./BillingRules.yaml?vue&type=script&lang=ts&component"
export * from "./BillingRules.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports